<script setup>

import {defineProps} from "vue";

const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  }
});

</script>

<template>
  <div v-if="props.loading" class="loader-container">
<!--    <img src="https://objectstorage.sa-bogota-1.oraclecloud.com/n/axwjzswungq4/b/Colombiana_Bucket/o/logos%2Fpromo-colombiana.webp" alt="">-->


    <div class="loader">
      <div class="loader-point"></div>
      <div class="loader-point"></div>
      <div class="loader-point"></div>
    </div>
  </div>


</template>

<style scoped>
.loader-container {
  height: 100vh;
  background-color: var(--yellow-color);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  img{
    width: 50%;
  }
}
.loader{
  display: flex;
  justify-content: center;
  align-self: center;
  margin: 0 auto;
}

.loader-point{
  width: 1.5rem;
  height: 1.5rem;
  margin: 3rem .5rem;
  border-radius: 50%;
  background-color: #ffffff;
  animation: loader .6s infinite alternate;
}

@keyframes loader {
  to{
    opacity: .1;
    transform: translate3d(0, -1rem, 0);
  }
}

.loader-point:nth-child(2){
  animation-delay: .2s;
}

.loader-point:nth-child(3){
  animation-delay: .4s;
}
</style>
